import * as types from '../constants/penlyplay';

export function resetPenlyPlayState(state) {
    return dispatch => {
        dispatch({ type: types.PENLYPLAY_RESET, payload: state });
    };
}

export function updatePenlyPlayState(state) {
    return dispatch => {
        dispatch({ type: types.PENLYPLAY_STATE_UPDATED, payload: { ...state } });
        return state;
    };
}
